import React from 'react';
import './QBCard.scss';
import { useTranslation } from 'react-i18next';
import { businessCurrency } from '@/features/Language/api/getCountryCurrency';
import { useAuth } from '@/lib/auth';
type QBCardProps = {
  data: any;
  columns: any;
  dataIndex: number;
};

const QBCard = ({ data, columns, dataIndex }: QBCardProps) => {
  const { t, i18n } = useTranslation();
  const { user } = useAuth();
  const currency = businessCurrency(user, 'USD');
  const filterColIndex = columns.findIndex((col: any) => col.ColTitle === 'Name');
  return (
    <div className={`QB-card`}>
      <h5>{data?.ColData[filterColIndex].value}</h5>
      {columns.map((col: any, colIndex: number) => (
        <>
          {col.ColTitle !== 'Name' && (
            <div className="transaction-details">
              <div className="label">{col.ColTitle}</div>
              <div className="details">
                {col.ColType.toLowerCase() === 'money' ? `${currency} $` : ''}
                {data?.ColData[colIndex].value}
              </div>
            </div>
          )}
        </>
      ))}
    </div>
  );
};

export default QBCard;
